import { render } from "./BarraNavegacion.vue?vue&type=template&id=23dc68e8"
import script from "./BarraNavegacion.vue?vue&type=script&lang=js"
export * from "./BarraNavegacion.vue?vue&type=script&lang=js"

import "./BarraNavegacion.vue?vue&type=style&index=0&id=23dc68e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__